import { getDefaultDetailsForPage } from "../shell/sidebar/navigationItems";

// Warehouse entities the sitemap has no page for.
const warehouseEntityNames: Record<string, string> = {
  warehouseapplication: "Warehouse Application",
  warehouseconfiguration: "Warehouse Configuration",
};

/** The name the sitemap gives an entity's record, e.g. "Competition Stage" for dwcompetitionstage. */
export function getEntityFriendlyName(entityName: string): string {
  const name = entityName.trim().toLowerCase();

  if (warehouseEntityNames[name]) {
    return warehouseEntityNames[name];
  }

  const candidates = [name, name.replace(/^dw/, "")];

  for (const candidate of candidates) {
    const recordName = getDefaultDetailsForPage(candidate).RecordName;

    if (recordName) {
      return recordName;
    }
  }

  return entityName;
}
